export default {
      id: "as-sign-language-usage",
      viewBox: "0 0 56 56",
      url: "/" + "sprite.svg#as-sign-language",
      toString: function () {
        return this.url;
      }
    }